/**
 * Brand colors, see https://brandcenter.jnj.com/document/416#/visual-identity/color/color-values
 */
export class BrandColors {
	// If any of these change, update the correspondaing code in variables.scss
	public static PrimaryBrand = 'rgb(235, 23, 0)';

	public static White = 'rgb(255, 255, 255)';
	public static Black = 'rgb(0, 0, 0)';

	public static Accent01 = 'rgb(251, 224, 88)';
	public static Accent02 = 'rgb(255, 96, 23)';
	public static Accent03 = 'rgb(158, 0, 0)';
	public static Accent04 = 'rgb(177, 155, 235)';
	public static Accent05 = 'rgb(140, 59, 187)';
	public static Accent06 = 'rgb(84, 25, 128)';
	public static Accent07 = 'rgb(105, 208, 255)'; // Blue 01
	public static Accent08 = 'rgb(15, 104, 178)'; // Blue 03
	public static Accent09 = 'rgb(0, 70, 133)'; // Blue 05
	public static Accent10 = 'rgb(83, 206, 118)'; // Green 01
	public static Accent11 = 'rgb(50, 135, 20)'; // Green 03
	public static Accent12 = 'rgb(59, 90, 13)'; // Green 05

	public static Neutral01 = 'rgb(249, 248, 247)';
	public static Neutral02 = 'rgb(241, 239, 237)';
	public static Neutral03 = 'rgb(232, 230, 227)';
	public static Neutral04 = 'rgb(213, 207, 201)';
	public static Neutral05 = 'rgb(193, 187, 179)';
	public static Neutral06 = 'rgb(163, 153, 146)';
	public static Neutral07 = 'rgb(129, 118, 111)';
	public static Neutral08 = 'rgb(86, 76, 71)';

	// This is not in variables.scss, but came from the specification
	// from Kenneth
	public static WarmGray2 = 'rgb(203,196,188)';
	public static Maroon05 = 'rgb(158,0,0)';
}
